import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CloseCardModalProps {
  cardName: string;
  closing: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function CloseCardModal({ cardName, closing, onCancel, onConfirm }: CloseCardModalProps) {
  return (
    <div className="text-center">
      <div className="mx-auto mb-[1.8rem] flex h-[5.6rem] w-[5.6rem] items-center justify-center rounded-full border-[0.2rem] border-[#F36B6B] text-[#F36B6B]">
        <X className="h-[3rem] w-[3rem]" strokeWidth={1.5} />
      </div>
      <h2 className="text-[2rem] font-semibold leading-[2.8rem] text-main">Permanently close {cardName}?</h2>
      <div className='flex flex-col gap-[0.8rem]'>
        <p className="mt-[1.6rem] font-normal text-[1.5rem] leading-[1.3] tracking-[0] text-center text-main">
          Your funds and account data remain completely safe, but this card will be <strong className="font-semibold text-main">permanently deactivated</strong> and cannot be reopened.
        </p>
        <p className='font-normal text-[1.5rem] leading-[1.3] tracking-[0] text-center text-main'>If you only need to stop new transactions temporarily, pause the card instead.</p>
      </div>

      <div className="mt-[2.4rem] grid grid-cols-2 gap-[1rem]">
        <Button type="button" variant="outline" size="sz44" disabled={closing} onClick={onCancel} className="w-full text-[1.3rem]">Cancel</Button>
        <Button type="button" variant="destructive" size="sz44" disabled={closing} onClick={onConfirm} className="w-full text-[1.3rem]">
          {closing ? 'Closing…' : 'Yes, close it now'}
        </Button>
      </div>
    </div>
  );
}
